module.exports = __webpack_public_path__ + "img/05.9044ea83.jpg";